import Modal from 'react-modal';
import './styles.scss';

const DeleteRoleErrorModal = ({ closeModal }) => {
  const handleClose = () => {
    closeModal();
  };

  return (
    <Modal
      className="modal-alert delete-role-error-modal"
      isOpen
      onRequestClose={handleClose}
      contentLabel="Delete note modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5" width="38" height="38" rx="19" fill="#FEE4E2" />
          <rect x="5" y="5" width="38" height="38" rx="19" stroke="#FFF2F1" strokeWidth="10" />
          <g clipPath="url(#clip0_13465_79709)">
            <path
              d="M23.9999 21.3359V24.0026M23.9999 26.6693H24.0066M30.6666 24.0026C30.6666 27.6845 27.6818 30.6693 23.9999 30.6693C20.318 30.6693 17.3333 27.6845 17.3333 24.0026C17.3333 20.3207 20.318 17.3359 23.9999 17.3359C27.6818 17.3359 30.6666 20.3207 30.6666 24.0026Z"
              stroke="#B42318"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_13465_79709">
              <rect width="16" height="16" fill="white" transform="translate(16 16)" />
            </clipPath>
          </defs>
        </svg>

        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Cannot delete line with assigned staff</h3>
        <p className="modal-subtitle">
          This line cannot be deleted because a staff member is already assigned to a shift here. Please remove the assigned shift before
          deleting the line.
        </p>
      </div>
      <div className="modal-footer"></div>
    </Modal>
  );
};

export default DeleteRoleErrorModal;
